import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Select,
} from '@mui/material'
import React from 'react'

export default function ExportButton({
  fields,
  data,
  exportFileName,
}: {
  fields: string[]
  data: Record<string, any>[]
  exportFileName?: string
}) {
  const [open, setOpen] = React.useState(false)
  const [delimiter, setDelimiter] = React.useState(',')

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const selectedDelimiter = delimiter

    // Convert objects to CSV format
    const csvContent = [
      fields.join(selectedDelimiter), // Header row
      ...data.map((obj) =>
        fields.map((field) => obj[field] || '').join(selectedDelimiter)
      ),
    ].join('\n')

    // Create a Blob and download it
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', exportFileName + '.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    handleClose()
  }

  return (
    <React.Fragment>
      <Button variant="outlined" onClick={handleClickOpen}>
        Exporter les données
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Exporter les données</DialogTitle>
        <DialogContent sx={{ paddingBottom: 0 }}>
          <DialogContentText>
            Choisissez le delimiteur du fichier exporté
          </DialogContentText>
          <form onSubmit={handleSubmit}>
            <Select
              labelId="delimiter-select-label"
              id="delimiter-select"
              value={delimiter}
              label="delimiter"
              onChange={(event) => setDelimiter(event.target.value)}
            >
              <MenuItem value={','}>,</MenuItem>
              <MenuItem value={';'}>;</MenuItem>
              <MenuItem value={'|'}>|</MenuItem>
              <MenuItem value={'tab'}>Tabulation</MenuItem>
            </Select>
            <DialogActions>
              <Button onClick={handleClose}>Annuler</Button>
              <Button type="submit">Exporter</Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}
